import React from 'react'

export default props =>  
  <section id="content">
    {props.children}
  </section>